var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaveAnytimeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.08789,
    y: 14.6445,
    width: 34.1631,
    height: 26.9092,
    rx: 2,
    fill: "#37315B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 25.7041H27.6836V47.6459H15.4785",
    fill: "#987DD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4785 25.7041H27.6836V47.6459H15.4785",
    stroke: "#CCB7F8",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25.7046V47.6464L15.4794 50.3892V22.9619L3 25.7046Z",
    fill: "#E3D7FB",
    stroke: "#CCB7F8",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2285 35.3037V38.0464",
    stroke: "#524372",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9346 34.8056L34.3933 37.2644L31.9346 39.7231",
    stroke: "#F8F5FE",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.126 34.8056L26.5847 37.2644L24.126 39.7231",
    stroke: "#F8F5FE",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5245 13.1988H30.2636C30.0355 13.1988 29.8506 13.3837 29.8506 13.6119V19.3944C29.8506 19.6226 30.0355 19.8075 30.2636 19.8075H38.5245C38.7526 19.8075 38.9375 19.6226 38.9375 19.3944V13.6119C38.9375 13.3837 38.7526 13.1988 38.5245 13.1988Z",
    fill: "#987DD2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5245 13.1988H30.2636C30.0355 13.1988 29.8506 13.3837 29.8506 13.6119V19.3944C29.8506 19.6226 30.0355 19.8075 30.2636 19.8075H38.5245C38.7526 19.8075 38.9375 19.6226 38.9375 19.3944V13.6119C38.9375 13.3837 38.7526 13.1988 38.5245 13.1988Z",
    stroke: "#CCB7F8",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5354 13.1988V11.3401C32.5354 10.8472 32.7312 10.3744 33.0798 10.0258C33.4283 9.67727 33.9011 9.48145 34.3941 9.48145C34.887 9.48145 35.3598 9.67727 35.7083 10.0258",
    stroke: "#CCB7F8",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveAnytimeIcon);
export default __webpack_public_path__ + "static/media/leaveAnytime-icon.6a19e7bac55095518d32ec92074070ea.svg";
export { ForwardRef as ReactComponent };